import React, { useMemo, useState } from 'react';

import { Space } from '@sravni/react-design-system';
import { PAGE_TYPE } from '@sravni/ugc/lib/organizations/constants';

import { getServicesOptions } from '../../../../helpers/reviews';
import { IReviewFilters } from '../../../../interfaces/reviews';
import { useProductsList } from '../../../../store/hooks/products';
import { useServicesRating } from '../../../../store/hooks/ratings';
import { useReviewsCount, useSqueezeItems } from '../../../../store/hooks/reviews';
import { IListHeaderProps } from '../../index';
import styles from '../../reviews-list-header.module.scss';
import { ProductsBlock } from '../ProductsBlock';
import { SqueezeBlock } from '../SqueezeBlock';

export interface IProductsAndSqueezeBlock extends Pick<IListHeaderProps, 'typePage' | 'filters' | 'handleChange'> {
  product?: { tag: string; alias: string };
  type: PAGE_TYPE;
  serverFilters: IReviewFilters;
  organizationAlias?: string;
  isMobile?: boolean;
  showProductsBlock?: boolean;
}

export const ProductsAndSqueezeBlock: React.FC<IProductsAndSqueezeBlock> = (props) => {
  const {
    product,
    serverFilters,
    typePage,
    organizationAlias,
    type,
    isMobile,
    showProductsBlock,
    filters,
    handleChange,
  } = props;
  const { groupedByServices: reviewsCount } = useReviewsCount();
  const servicesRating = useServicesRating();
  const products = useProductsList();
  const squeezeItems = useSqueezeItems();

  const [localServiceFilters, setLocalServiceFilters] = useState<IReviewFilters>(serverFilters);

  const servicesOptions = useMemo(() => {
    return product
      ? products?.[product?.tag]?.filter(({ id }) => id !== 'All')
      : getServicesOptions(localServiceFilters, reviewsCount, typePage, servicesRating);
  }, [product, products, localServiceFilters, reviewsCount, typePage, servicesRating]);

  const handleCloseProductModal = () => setLocalServiceFilters(serverFilters);

  const squeezeItemsToShow = squeezeItems?.filter((item) => item.count > 2);
  const showProductsBlockLoc = showProductsBlock && servicesOptions?.length > 0;
  const showSqueezeBlock = squeezeItemsToShow?.length > 0;

  if (!showProductsBlockLoc && !showSqueezeBlock) return null;

  return (
    <Space className={styles.wrapper} direction={'vertical'} size={24}>
      {showProductsBlockLoc && (
        <ProductsBlock
          product={product}
          typePage={typePage}
          organizationAlias={organizationAlias}
          type={type}
          isMobile={isMobile}
          servicesOptions={servicesOptions}
          handleCloseProductModal={handleCloseProductModal}
        />
      )}
      {showSqueezeBlock && <SqueezeBlock items={squeezeItemsToShow} handleChange={handleChange} filters={filters} />}
    </Space>
  );
};
